import { CreateContextStateType, RaffleDrawAPIParams } from "@src/lib/types/create-raffle-draw";
import axiosClient from "@src/utils/axios-client";

export const allRafflesAPI = async (params?: { partnerId?: any; type?: string }) => {
  try {
    const result = await axiosClient.get('/admin/raffles/all', { params });
    return result.data || { items: [] };
  } catch (error: any) {
    throw error?.response?.data?.error || error?.message;
  }
};

export const allResultsAPI = async (params?: RaffleDrawAPIParams) => {
  try {
    const requestParams = {
      page: 1,
      size: 10,
      "sort":"drawAt,desc",
      ...params,
    };

    const result = await axiosClient.get(
      "/admin/raffles", { params: requestParams }
    );

    return result.data || {};
  } catch (error: any) {
    throw error.response.data.error;
  }
};

export const updateWinnerAPI = async (raffleId: number, params: { place: number; userId: number }) => {
  try {
    const res = await axiosClient.put(`/admin/raffles/${raffleId}/results/winners`, params);
    return res.data;
  } catch (error: any) {
    throw error?.response?.data?.message || error?.response?.data?.error || error?.message || 'Failed to update winner';
  }
};

export const raffleOverviewAPI = async (params?: { partnerId?: string }) => {
  try {
    const result = await axiosClient.get("/admin/raffles/overview", { params });
    return result.data || { items: [], count: 0 };
  } catch (error: any) {
    throw error?.response?.data?.error || error?.message;
  }
};

export const createAPI = async (params?: CreateContextStateType | any) => {
  try {
    const res = await axiosClient.post(
      "/admin/raffles",
      params
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const detailsAPI = async (id?: number, params?: any) => {
  try {
    const res = await axiosClient.get(`/mails/${id}`, { params });
    return res?.data?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const viewDetailsAPI = async (params?: any) => {
  try {
    const res = await axiosClient.get(`/admin/raffles/${params.id}`, {params});
    return res?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const updateDetailsAPI = async (params?: any) => {
  try {
    const res = await axiosClient.put(`/admin/raffles/${params.id}`, params);
    return res?.data?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const deleteAPI = async (params?: any) => {
  try {
    const res = await axiosClient.delete(`/admin/raffles/${params.id}`, {params});
    return res?.data?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const uploadImageAPI = async (params?: any) => {
  try {
    delete axiosClient.defaults.headers['Content-Type'];
    const res = await axiosClient.post(
      "/files/upload",
      params
    );
    return res;
  } catch (error) {
    throw error;
  }
};
